import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { getClothingMaterial } from 'controllers/ClothingMaterial';
import { sortArrayPipe } from 'shared/pipes';



class MaterialComposition extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   materials: [],
    //   selectedMaterial: '',
    // };
    this.state = {
      data: []
      // other state properties
    };
  }

  
  async componentDidMount() {

    async function dataStream(callback) {
      const cloth = await getClothingMaterial();
      callback(sortArrayPipe.transform(cloth, 'value'));
    }
    if (dataStream) {
      await dataStream((values) => {
          this.setState({ data: values });
        });
    }

}
 
  handleMaterialChange = (event) => {
    const { value } = event.target;
    if (value && !this.props.state.materialdata.materials.some(material => material.name === value)) {
           this.props.setState(prevState => ({
        materialdata: {
          ...prevState["materialdata"],
          materials: [...prevState.materialdata.materials, { name: value, percentage: '' }],
          selectedMaterial: ''
        }
      }));
    }
  };
  handleMaterialChange2 = (event) => {
    const { value } = event.target;
    if (value && !this.props.state.materialdata.materials.some(material => material.name === value)) {
      this.props.setState(prevState => ({
        ...prevState,
        product: {
          ...prevState["product"],
          materialdata: {
            ...prevState["product"]["materialdata"],
            materials: [...prevState.product.materialdata.materials, { name: value, percentage: '' }],
            selectedMaterial: ''   
          } 
        }
      }));
    }
  };

  handlePercentageChange2 = (index, event) => {

    const { value } = event.target;
    const { materials } = this.props.state.materialdata;

    materials[index].percentage = value;
    if (value <= 100 && value >= 0) {
      this.value += '%';
      this.props.setState(prevState => ({
        ...prevState,
        product: {
          ...prevState["product"],
          materialdata: {
            ...prevState["product"]["materialdata"],
            materials: materials,
            selectedMaterial: ''   
          } 
        }
      }));
    } else {
      event.preventDefault();
    }
    
  };
  handlePercentageChange = (index, event) => {
    const { value } = event.target;
    const { materials } = this.props.state.materialdata;
    materials[index].percentage = value;
    if (value <= 100 && value >= 0) {
      this.value += '%';
      this.props.setState(prevState => ({
        materialdata: {
          ...prevState["materialdata"],
          materials: materials,
          selectedMaterial: ''
        }
      }));
    } else {
      event.preventDefault();
    }
    
  };

  handleClearPercentage = (index) => {
    const { materials } = this.props.state.materialdata;
    materials.splice(index, 1); // Remove the material at the specified index
    this.props.setState(prevState => ({
      materialdata: {
        ...prevState["materialdata"],
        materials: [...materials], // Update the materials array without the removed material
      }
    }));
  };
  handleClearPercentage2 = (index) => {
    const { materials } = this.props.state.materialdata;
    materials.splice(index, 1); // Remove the material at the specified index
    this.props.setState(prevState => ({
      ...prevState,
      product: {
        ...prevState["product"],
        materialdata: {
          ...prevState["product"]["materialdata"],
          materials: [...materials],
        }
      }
    }));
  };

  render() {
    const { materials, selectedMaterial } = this.props.state.materialdata;
    const { className } = this.props;
    


    return (
      <div>
        <div className="field">

                    <label className="label">MATERIAL / COMPOSITION</label>
                    <div className={`select is-fullwidth ${className}`}>
        <select value={selectedMaterial} onChange={this.props.editscreenProp?this.handleMaterialChange2:this.handleMaterialChange}>
              <option value=""></option>
              {
                this.state.data.map((item) => (
                  <option key={item.id} value={item.value} disabled={materials.some(material => material.name === item.value)}>{ item.label}</option>
                ))
              }
         
          {/* Add more options as needed */}
            </select>
            </div>
        </div>
        <div style={{display:'flex',width:'100%'}}>
           <Grid container spacing={3}>
        {materials?.map((material, index) => (
          
           <Grid item lg={this.props.editscreenProp ? 12:3} md={this.props.editscreenProp ? 12:3} sm={this.props.editscreenProp ? 12:3} xs={12} >
          <div className="field" key={index}>
            <label className="label">{ material.name} %</label>
          <div className="control input-with-icon" style={{  position: "relative"}}>
              <input
                className= {this.props.editscreenProp ?"input":"input is-large"}
                style={{ paddingRight: "30px"}}
                type="number"
                max={100}
                min={0}
                placeholder="Percentage"
                value={materials[index].percentage || ''}
                onChange={(e) => this.props.editscreenProp?this.handlePercentageChange2(index, e):this.handlePercentageChange(index, e)}
                />
                <HighlightOffIcon style={{
                  position: "absolute",
                  top: "50%",
                  right: "5px", /* Adjust the distance from the right edge of the input field */
                  transform: "translateY(-50%)",
                  cursor: "pointer"
                }}  onClick={() => this.props.editscreenProp?this.handleClearPercentage2(index):this.handleClearPercentage(index)} />
                      
          </div>
            </div>
            </Grid>    
        ))}
             </Grid>


</div>
      </div>
    );
  }
}

export default MaterialComposition;
